<template>
<div id="serviceProviders">

    <v-row>
        <v-col cols="3">
            <v-text-field clearable placeholder="Search by company name, city, and service" @input="onSearch" outlined hide-details v-model="search"/>
        </v-col><v-spacer/>
        <v-btn large class="primary text-capitalize elevation-0 mt-2" @click="formDialog=true">Add Service Provider</v-btn>
    </v-row>

    <v-data-table :headers="headers" :items="serviceProviders" :server-items-length="serviceProvidersCount"
                  :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :options.sync="options" @update:page="$vuetify.goTo(0)"
                  @update:options="onUpdateOptions" :footer-props="{itemsPerPageOptions:rowsPerPageItems}">
        <template v-slot:no-data>No Service Provider Available</template>
        <template v-slot:no-results>No Service Provider Available</template>
        <template v-slot:item.image="{ item }">
            <v-avatar tile style="border: 1px solid grey; border-radius: 5px !important;" size="60" @click="openGallery([{path: item.image, type: 'IMAGE'}])" class="mr-6 avatar my-3" title="View Image">
                <v-img :src="imgWpx(item.image, 200)" :alt="item.name">
                    <template v-slot:placeholder>
                        <v-icon size="50" color="blue-grey lighten-5">mdi-image</v-icon>
                        <v-progress-circular width="3" size="24" indeterminate style="position: unset" color="deep-orange lighten-2"></v-progress-circular>
                    </template>
                </v-img>
            </v-avatar>
        </template>
        <template v-slot:item.isChargeable="{ item }">{{item.isChargeable?'Chargeable':'Free'}}</template>
        <template v-slot:item.created_at="{ item }">{{moment(item.created_at).format('DD MMM YY hh:mm A')}}</template>
        <template v-slot:item.isActive="{ item }">
            <v-switch inset dense color="success" v-model="item.isActive" @click.stop="" @change="onUpdateStatusOfServiceProvider(item)"/>
        </template>
        <template v-slot:item.action="{ item }">
            <v-menu nudge-bottom="25">
                <template v-slot:activator="{ on:menu }">
                    <v-btn small icon v-on="{...menu}"><v-icon>mdi-dots-vertical</v-icon></v-btn>
                </template>
                <v-list dense>
                    <v-list-item @click="onEditServiceProvider(item)"><v-list-item-title>Edit</v-list-item-title></v-list-item>
                    <v-list-item @click="onDeleteServiceProvider(item)"><v-list-item-title>Delete</v-list-item-title></v-list-item>
                </v-list>
            </v-menu>
        </template>
    </v-data-table>

    <ServiceProviderForm :dialog.sync="formDialog" :id.sync="serviceProviderId"/>
    <Snackbar :toaster="toaster"/>
    <ConfirmationDialog :confirmationMessage="confirm.message" @confirm="confirm.method" @close="confirm.closeMethod"
                        v-if="confirm.enable"/>
    <gallery id="gallery-service-providers" :images="galleryImages" :index="galleryIndex" @close="galleryIndex=null"/>
</div>
</template>

<script>
import Constants from "../../Constants/Constants";
import moment from 'moment';
import gallery from '../../mixins/gallery';
import {debounce} from "lodash";
import {generate_UPDATE_RECORD} from "../../graphql/mutations/Orders";
import Snackbar from "../../components/Common/Snackbar";
import ServiceProviderForm from "./ServiceProviderForm";
import {
    SUBSCRIBE_SERVICE_PROVIDERS,
    SUBSCRIBE_SERVICE_PROVIDERS_COUNT
} from "../../graphql/subscriptions/ServiceProviders";
import ConfirmationDialog from "../../components/Common/ConfirmationDialog";
import {DELETE_SERVICE_PROVIDER_BY_ID} from "../../graphql/mutations/ServiceProviders";
let options= {page: 1, itemsPerPage: 25, offset:0, limit:25};
export default {
    name: "ServiceProviders",
    components: {ConfirmationDialog, ServiceProviderForm, Snackbar},
    mixins: [gallery],
    apollo: {
        $subscribe: {
            serviceProvidersCount:{
                query: SUBSCRIBE_SERVICE_PROVIDERS_COUNT,
                variables () { return { search: this.providerSearch }},
                result ({ data }) { this.serviceProvidersCount = data.serviceProvidersCount.aggregate.count },
            },
            ServiceProviders:{
                query: SUBSCRIBE_SERVICE_PROVIDERS,
                variables () { return {
                    search: this.providerSearch, offset: this.options.offset, limit: this.options.limit,
                    orderBy: this.prepareSortObject(this.sortBy, this.sortDesc)
                }},
                result ({ data }) { this.serviceProviders = data.ServiceProviders },
            },
        }
    },
    data(){
        return{
            Constants: Constants,
            moment: moment,
            user: JSON.parse(localStorage.user),
            headers: [
                {text: 'PROVIDER IMAGE', value: 'image', sortable:false}, {text: 'COMPANY NAME', value: 'companyName'},
                {text: 'SERVICE NAME', value: 'ServiceCategory.name'}, {text: 'MOBILE', value: 'mobile'},
                {text: 'CITY', value: 'city'}, {text: 'SERVICE TYPE', value: 'isChargeable'},
                {text: 'EXPERIENCE (IN YEARS)', value: 'experience'}, {text: 'CREATED ON', value: 'created_at', width:100},
                { text: 'IS ACTIVE', value: 'isActive', sortable:false }, { text: 'ACTION', value: 'action', sortable:false }
            ],
            serviceProviders: [],
            serviceProvidersCount: 0,
            options: {...options}, rowsPerPageItems: [25, 50, 100, -1],
            search: '', providerSearch: '%%',
            sortBy: ['companyName'], sortDesc: [false],
            formDialog: false,
            serviceProviderId: null,
            toaster: {enable: false},
            confirm: {enable: false},
        }
    },
    methods:{
        prepareSortObject([sortBy], [order]) {
            order = order ? 'desc' : 'asc';
            if (['created_at', 'companyName', 'mobile', 'city', 'isChargeable', 'experience'].includes(sortBy)) return {[sortBy]: order};
            if (sortBy === 'ServiceCategory.name') return {ServiceCategory: {name: order}};
            return null
        },
        onEditServiceProvider(row){
            this.serviceProviderId = row.id;
            this.formDialog = true;
        },
        onDeleteServiceProvider(row){
            this.confirm = {enable:true, message:'Are you sure want to delete Service Provider?',
                            row, method:this.deleteServiceProviderById, closeMethod:this.closeConfirmPopup};
        },
        async deleteServiceProviderById(){
            let id = this.confirm.row.id;
            let response = await this.$apollo.mutate({
                mutation: DELETE_SERVICE_PROVIDER_BY_ID,
                variables: { id: id }
            });
            if(response.data){
                this.confirm = {enable: false};
                this.toaster = {enable:true, color:'green', message: 'Service Provider deleted successfully'}
            }
        },
        closeConfirmPopup(){
            this.confirm = {enable: false};
        },
        onUpdateStatusOfServiceProvider(row){
            this.confirm = {enable:true, message:`Are you sure want to ${row.isActive?'Active':'Inactive'} Service Provider?`,
                            row, method:this.updateStatusOfServiceProvider, closeMethod:this.revertStatus};
        },
        revertStatus(){
            this.confirm.row.isActive = !this.confirm.row.isActive;           /* Revert value */
            this.confirm = {enable: false};
        },
        async updateStatusOfServiceProvider(){
            let row = this.confirm.row;
            let obj = { isActive: row.isActive, updatedBy: this.user.id};
            await this.updateRecord(row.id, obj, 'ServiceProviders');
            this.confirm = {enable: false};
            this.toaster = {enable:true, color:'green', message: `Status of Service Provider Updated Successfully`}
        },
        async updateRecord(id, obj, table) {
            let response = await this.$apollo.mutate({
                mutation: generate_UPDATE_RECORD(table),
                variables: {id: id, obj: obj}
            })
            if (response.data) return Promise.resolve(response.data);
        },
        onUpdateOptions(val){
            if(val.itemsPerPage === -1){                                            //'ALL' Rows per page
                this.options.limit = this.serviceProvidersCount;                    //assign total count
                this.options.offset = 0
            }else{
                this.options.limit = val.itemsPerPage;
                this.options.offset = (val.page -1) * val.itemsPerPage;
            }
        },
        onSearch: debounce(function(val){
            this.providerSearch = val?('%'+val+'%'):'%%'
            this.options = {...options}             //on search, reset page options
        }, 500),
    }
}
</script>

<style scoped>
#serviceProviders{
    padding: 12px;
}
</style>